import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

type ManualToolModal = {
	open: boolean,
	showAllFacets: boolean;
	inputFieldsEdited: boolean;
	resetEnabled: boolean;
};

const initialState: { data: ManualToolModal } = {
	data: {
		open: false,
		showAllFacets: true,
		inputFieldsEdited: false,
		resetEnabled: false,
	}
};

export const ManualToolModalSlice = createSlice({
	name: 'ManualToolModalProvider',
	initialState,
	reducers: {
		toggleManualToolModalState(state, action: PayloadAction<{ value: boolean, showAll?: boolean, inputFieldsEdited?: boolean }>) {
			state.data.open = action.payload.value;
			state.data.showAllFacets = !!action.payload.showAll;
		},
		toggleManualToolDoneButtonState(state, action: PayloadAction<{ inputFieldsEdited: boolean }>) {
			state.data.inputFieldsEdited = action.payload.inputFieldsEdited;
		},
		toggleManualToolResetButtonState(state, action: PayloadAction<{ resetEnabled: boolean }>) {
			state.data.resetEnabled = action.payload.resetEnabled;
		}
	}
});

export const { toggleManualToolModalState, toggleManualToolDoneButtonState, toggleManualToolResetButtonState } = ManualToolModalSlice.actions;

export default ManualToolModalSlice.reducer;